import http from '../_http_v2';

const detect = {
  //default
  list: (m) => { return http.post(`console/wmds/detect/list`, m); },
  detail: (m) => { return http.get(`console/wmds/detect/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wmds/detect`, m); },
  delete: (m) => { return http.delete(`console/wmds/detect/${m.id}`); }
}

export default detect

export { detect }